import { render, staticRenderFns } from "./Royalties.vue?vue&type=template&id=1086a8b6&scoped=true&"
import script from "./Royalties.vue?vue&type=script&lang=js&"
export * from "./Royalties.vue?vue&type=script&lang=js&"
import style0 from "./Royalties.vue?vue&type=style&index=0&id=1086a8b6&scoped=true&lang=css&"
import style1 from "./Royalties.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1086a8b6",
  null
  
)

export default component.exports